import { z } from 'zod';

const schema = z.object({
  VITE_API_BASE_URL: z.string().optional(),
  VITE_POWERLIFTING_LIVE_BASE_URL: z.string().optional(),
});

export const env = schema.parse(import.meta.env);
